import dynamic from "next/dynamic";
import YoutubeVideoAssetConfig from "./youtube-video-asset-config";
import YoutubeVideoAssetAdvancedConfig from "./youtube-video-asset-advanced-config";
const YoutubeVideoAssetComponent = dynamic(()=>import("./youtube-video-asset-component"));
export default {
    YoutubeVideoAssetComponent,
    YoutubeVideoAssetConfig,
    YoutubeVideoAssetAdvancedConfig
};
